import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute, NavigationEnd, Params, PRIMARY_OUTLET } from "@angular/router";
import "rxjs/add/operator/filter";

interface IBreadcrumb {
  label: string;
  params?: Params;
  url: string;
}

@Component({
  selector: "breadcrumb",
  template: `
  <div *ngIf="breadcrumbs?.length > 1">
    <a [routerLink]="[breadcrumbs[breadcrumbs.length - 3].url]"><span class="glyphicon glyphicon-arrow-left glyphicon-pointer" style="padding-top: 13px; font-size: 18px;"></span></a>
  </div>
  <div *ngIf="breadcrumbs?.length === 1 && breadcrumbs[0].label !== 'Dashboard' && breadcrumbs[0].label !== 'Thank You' && breadcrumbs[0].label !== 'Exam Survey'">
    <a [routerLink]="['/dashboard']"><span class="glyphicon glyphicon-arrow-left glyphicon-pointer" style="padding-top: 13px; font-size: 18px;"></span></a>
  </div>
  `
})
export class BreadcrumbComponent implements OnInit {

  public breadcrumbs: IBreadcrumb[];

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.breadcrumbs = [];
  }
  
  ngOnInit() {
    const ROUTE_DATA_BREADCRUMB: string = "breadcrumb";

    //subscribe to the NavigationEnd event
    this.router.events.filter(event => event instanceof NavigationEnd).subscribe(event => {
      
      //set breadcrumbs
      let root: ActivatedRoute = this.activatedRoute.root;
      this.breadcrumbs = this.getBreadcrumbs(root);
    });
  }
  
  private getBreadcrumbs(route: ActivatedRoute, url: string=""): IBreadcrumb[] {
    const ROUTE_DATA_BREADCRUMB: string = "breadcrumb";
    const ROUTE_DATA_BREADCRUMB_RESET: string = "reset";

    //get the child routes
    let children: ActivatedRoute[] = route.children;

    //return if there are no more children
    if (children.length === 0) {
       return this.breadcrumbs;
    }

    //iterate over each children
    for (let child of children) {
      //verify primary route
      if (child.outlet !== PRIMARY_OUTLET) {
        continue;
      }

      //verify the custom data property "breadcrumb" is specified on the route
      if (!child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB)) {
        continue;
      }
      
      //verify the custom data property "breadcrumb" is specified on the route
      if (!child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB_RESET)) {
        continue;
      }

      //reset breadcrumb if a tab is selected
      if (child.snapshot.data[ROUTE_DATA_BREADCRUMB_RESET]) {
        this.breadcrumbs= [];
      }

      //get the route's URL segment
      let routeURL: string = child.snapshot.url.map(segment => segment.path).join("/");

      //append route URL to URL
      url += `/${routeURL}`;

      //add breadcrumb
      let breadcrumb: IBreadcrumb = {
        label: child.snapshot.data[ROUTE_DATA_BREADCRUMB],
        params: child.snapshot.params,
        url: url
      };

      let found: boolean = false;
      let tmpBreadcrumb = [];
      let tmpCrumb: IBreadcrumb = { label: '/', params: undefined, url: '/'};

      for (let i = 0; i < this.breadcrumbs.length; i++) {
        tmpBreadcrumb.push(this.breadcrumbs[i]);

        if (this.breadcrumbs[i].url === breadcrumb.url) {
          found = true;
          break;
        }
      }

      if (tmpBreadcrumb.length > 0) {
        this.breadcrumbs = tmpBreadcrumb;
        if (!found) {
          tmpBreadcrumb.push(tmpCrumb);
          this.breadcrumbs.push(breadcrumb);
        }
      } else {
        this.breadcrumbs.push(breadcrumb);
      }
      
      //recursive
      return this.getBreadcrumbs(child, url);
    }
    
    //we should never get here, but just in case
    return this.breadcrumbs;
  }
}